import { ChevronRight } from "../../shell/approved-icons.js";
import { settingsSections } from "../settings/settings-sections.js";
import { AdminViewSwitcher } from "../../shell/admin-view-controls.js";
import { ApprovedAvatar } from "../../shell/approved-primitives.js";
import { Button } from "@/components/ui/button";
import type { ProductPageKey } from "../../../shared/contracts/product-pages.js";
import "../../styles/more-approved.css";
import { openInstallHelp, useInstallState } from "../../pwa/install-browser.js";

export function MorePage(props: {
  role: "user" | "admin";
  displayName?: string;
  handicapDisplay?: number | null;
  onOpenProfile(): void;
  onNavigate(page: ProductPageKey): void;
}): React.JSX.Element {
  const name = props.displayName ?? "Your profile";
  return (
    <section className="fr-more-page fr-more-page--art" aria-label="More">
      <header className="fr-more-player">
        <div className="fr-more-player-copy">
          <span className="fr-more-eyebrow">YOUR PLAYER CARD</span>
          <div className="fr-more-player-heading">
            <h1>{name}</h1>
            <button
              className="fr-more-photo-link"
              onClick={props.onOpenProfile}
              aria-label="Open player card and edit profile"
            >
              <ApprovedAvatar name={name} self size={64} />
            </button>
          </div>
          <div className="fr-more-player-bottom">
            <div className="fr-more-handicap">
              <strong>{props.handicapDisplay ?? "—"}</strong>
              <span>
                HANDICAP INDEX
                <small>
                  {props.handicapDisplay == null
                    ? "Not added"
                    : "Self-reported"}
                </small>
              </span>
            </div>
            <Button variant="gold-gradient" onClick={props.onOpenProfile}>
              Edit profile
            </Button>
          </div>
        </div>
      </header>
      <MoreMenu role={props.role} onNavigate={props.onNavigate} />
    </section>
  );
}

function MoreMenu(props: {
  role: "user" | "admin";
  onNavigate(page: ProductPageKey): void;
}) {
  const install = useInstallState();
  return (
    <div className="fr-more-content">
      {!install.standalone ? (
        <button
          type="button"
          className="fr-more-menu-link"
          onClick={openInstallHelp}
        >
          <span className="fr-more-setting-copy">
            <strong>Add to home screen</strong>
          </span>
          <ChevronRight size={17} />
        </button>
      ) : null}
      {settingsSections.map((section) => (
        <button
          key={section.id}
          type="button"
          className="fr-more-menu-link"
          onClick={() => {
            props.onNavigate("settings");
            window.history.replaceState(
              null,
              "",
              `/settings?section=${section.id}`,
            );
          }}
        >
          <span className="fr-more-setting-copy">
            <strong>{section.title}</strong>
            {["account", "privacy"].includes(section.id) ? (
              <small>{section.description}</small>
            ) : null}
          </span>
          <ChevronRight size={17} />
        </button>
      ))}
      <button
        className="fr-more-menu-link"
        onClick={() => props.onNavigate("reviews")}
      >
        <span className="fr-more-setting-copy">
          <strong>Results to review</strong>
        </span>
        <ChevronRight size={17} />
      </button>
      <a className="fr-more-menu-link" href="/privacy">
        <span className="fr-more-setting-copy">
          <strong>Privacy policy</strong>
        </span>
        <ChevronRight size={17} />
      </a>
      <AdminViewSwitcher />
      {props.role === "admin" && (
        <button
          className="fr-more-menu-link"
          onClick={() => props.onNavigate("admin")}
        >
          <span className="fr-more-setting-copy">
            <strong>Admin reviews</strong>
          </span>
          <ChevronRight size={17} />
        </button>
      )}
    </div>
  );
}
